export default __webpack_public_path__ + "static/media/team_values.1f1634e6.svg";